import { EventEmitter } from '../../../../../FrontendBundle/Resources/js/ofcs';

/**
 * @class LocalStorageAdapter
 * @extends EventEmitter
 */
export default class LocalStorageAdapter extends EventEmitter {
    /**
     * @type {string}
     * @private
     */
    _key = null;

    /**
     * @type {Storage}
     * @private
     */
    _storage = null;

    /**
     * Creates a new local storage adapter
     *
     * @param {Window} window The window element
     * @param {string} key Key for storage item in #localStorage
     */
    constructor(window, key) {
        super();
        this._key = key;
        this._storage = window.localStorage;
        window.addEventListener('storage', () => this.trigger('change'));
    }

    /**
     * Set the internal storage object. This is mainly used for testing
     *
     * @param {Storage} storage
     */
    setStorage(storage) {
        this._storage = storage;
    }

    /**
     * Stores given item attribute objects to browsers local storage
     *
     * @param {string} context
     * @param {Array} items
     */
    setItems(context, items) {
        this._storage.setItem(this._key, JSON.stringify({ context, items }));
        this.trigger('change');
    }

    /**
     * Returns item attribute objects from browsers local storage
     *
     * @param {string} context
     * @return {Object[]} Array with item attribute objects
     */
    getItems(context) {
        const data = JSON.parse(this._storage.getItem(this._key)) || { context: null, items: [] };

        if (context === data.context) return data.items;

        return [];
    }

    /**
     * Returns if the storage contains items
     *
     * @param {string} context
     * @return {boolean}
     */
    hasItems(context) {
        const data = this.getItems(context);
        return data.length > 0;
    }

    /**
     * Clears the storage
     */
    clear() {
        this._storage.removeItem(this._key);
        this.trigger('change');
    }
}
